import styles from './Gallery.css';
import {streamScreenDimensions} from '../../Applications/Utils/streamScreenDimensions';

export default ($node: HTMLElement) => {
	const $toggler = Array.from($node.querySelectorAll('[data-toggle]'));
	const $targets = Array.from($node.querySelectorAll('[data-target]'));
	const $controls = Array.from($node.querySelectorAll('[data-control]'));
	const $container = $node.querySelector('[data-select="container"]');
	const $presentation = $node.querySelector('[data-select="presentation"]');

	const count = $toggler.length;

	if ($targets.length && $container && $presentation) {
		// Store current visible item in overlay.
		let currentIndex = 0;

		// Show gallery. Open with given item.
		const openGallery = (e: Event) => {
			if (e.target instanceof HTMLImageElement) {
				const {toggle: index = '0'} = (e.currentTarget! as HTMLElement).dataset;

				$node.classList.add(styles.isInPresentationMode);
				currentIndex = parseInt(index, 10);
				showItem();
			}
		};

		// Hide gallery.
		const closeGallery = () => {
			$node.classList.remove(styles.isInPresentationMode);
			// This avoids flickering of previous image when re-opening presentation.
			currentIndex = -1;
			showItem();
		};

		// Show stored item in overlay.
		const showItem = () => {
			$targets.forEach(($target, index) => $target.classList.toggle(styles.isVisible, index === currentIndex));
		};

		// Handle inputs.
		const navigate = (direction: string) => {
			switch (direction) {
				case 'prev':
					currentIndex = (currentIndex + count - 1) % count;
					break;
				case 'next':
					currentIndex = (currentIndex + 1) % count;
					break;
				case 'close':
					closeGallery();
					return;
				default:
					return;
			}

			showItem();
		};

		// Add listener.
		$toggler.forEach($node => $node.addEventListener('click', openGallery, false));

		$controls.forEach($control => {
			const {control = ''} = ($control as HTMLElement).dataset;
			$control.addEventListener('click', () => navigate(control), false);
		});

		// Resize Presentation on Screen-resize.
		const onResize = () => {
			const {width, height} = $container.getBoundingClientRect();

			($presentation as HTMLElement).style.maxWidth = `calc(95% * ${height / width})`;
			$presentation.classList.toggle(styles.isPortrait, height > width);
		};

		streamScreenDimensions.subscribe(onResize);
	}
};
